import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { imagesMicrositeAPIService } from '~/api/microsites/images';
import { CustomDropZone } from '~/components/atoms/CustomDropZone';
import GridSelector from '~/components/atoms/GridSelector';
import { UploadedImagePreview } from '~/components/atoms/UploadedImagePreview';
import Accordion from '~/components/ui/Accordion/Accordion';
import useBuilderBlockMaxWidth from '~/hooks/useBuilderBlockMaxWidth';
import { useAppDispatch } from '~/hooks/useRedux';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { imagesSlice } from '~/store/reducers/previewScreens/images';
import { updateImagesSiteThunk } from '~/store/reducers/previewScreens/images';
import { getImagesReducer } from '~/store/reducers/previewScreens/images/selectors';

export default function BasicInformation() {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const { actions } = imagesSlice;

  const { micrositeData, imagesType, images } = useSelector(getImagesReducer);

  let currentIndex = images.length;

  const gridSelectorMaxWidth = useBuilderBlockMaxWidth();

  const addImages = (files) => {
    let newImages = files.map((itemFile) => {
      return {
        img: itemFile.previewLink,
        title: itemFile.name,
        imageStorageId: itemFile.imageStorageId,
        size: itemFile.size,
        microsite: micrositeData?.id,
        isLoading: true,
        index: currentIndex++,
      };
    });

    dispatch(actions.setImages([...images, ...newImages]));

    newImages.forEach(async (item, index) => {
      const res = await imagesMicrositeAPIService.addImage({
        title: item.title,
        image_id: item.imageStorageId,
        size: item.size,
        microsite: item?.microsite,
        position: item.index,
      });

      if (res?.data?.id) {
        newImages = newImages.map((item, currentIndex) =>
          currentIndex === index ? { ...item, id: res?.data?.id, isLoading: false } : item,
        );

        dispatch(actions.setImages([...images, ...newImages]));
      }
    });
  };

  const removeImage = async (id) => {
    imagesMicrositeAPIService.removeImage(id);

    dispatch(actions.setImages(images.filter((item) => item?.id !== id)));
  };

  const handleChangeGridType = (images_view_type) => {
    dispatch(
      updateImagesSiteThunk({
        id: micrositeData?.id,
        body: {
          images_view_type,
        },
        dispatchHandler: () => dispatch(actions.setImagesType(images_view_type)),
      }),
    );
  };

  return (
    <CreateQRContentBlockLayout type="basicInfo">
      <Accordion
        defaultExpanded
        variant="child"
        hideBottomBorder
        summary={t('template2:titleImages')}
        details={
          <>
            <CustomDropZone
              maxSizeInKb={15000}
              fileTypes={t('other:images')}
              maxSize={15}
              onDrop={(files) => addImages(files)}
              acceptTypes="image/*"
            />
            {images.map((item) => {
              return (
                <UploadedImagePreview
                  key={item.id}
                  imageName={item?.title}
                  imageSize={item?.size}
                  id={item.id}
                  deleteHandler={removeImage}
                  isLoading={item.isLoading}
                  imgSrc={item.img || item.image}
                />
              );
            })}
            <GridSelector
              maxWidth={gridSelectorMaxWidth}
              setImagesType={handleChangeGridType}
              defaultImageType={imagesType}
            />
          </>
        }
      />
    </CreateQRContentBlockLayout>
  );
}
